/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const orgOrganizationStaffOpenShiftCreatePathOrganizationIdSchema = z.uuid();

export const orgOrganizationStaffOpenShiftCreatePathStaffIdSchema = z.uuid();

export const orgOrganizationStaffOpenShiftCreateStatus200Schema = z.any();

export const orgOrganizationStaffOpenShiftCreateResponseSchema = orgOrganizationStaffOpenShiftCreateStatus200Schema;
